import { createReducer, on } from '@ngrx/store';
import { IAcademicClass } from '../../models/academic';
import { resetAppState } from '../global/global.actions';
import { AcademicClassActions } from './academic.actions';

export const itemsFeatureKey = 'academics';

export interface AcademicClassState {
    classes: IAcademicClass[];
    selectedClass: IAcademicClass | null;
    loading: boolean;
    error: unknown | null;
}

export const initialState: AcademicClassState = {
    classes: [],
    selectedClass: null,
    loading: false,
    error: null
};

export const academicClassReducer = createReducer(
    initialState,
    on(AcademicClassActions.loadClasses, state => ({
        ...state,
        loading: true,
        error: null
    })),
    on(AcademicClassActions.loadClassesSuccess, (state, { classes }) => {
        return {
            ...state,
            classes,
            loading: false,
            error: null
        };
    }),
    on(AcademicClassActions.loadClassesFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(AcademicClassActions.selectClass, (state, { id }) => ({
        ...state,
        selectedClass: state.classes.find(academicClass => academicClass.id === id) || null
    })),
    on(resetAppState, () => initialState)
);
